/* * @Author: tangxq * @Date: 2021-07-12 14:31:55 * @Last Modified by: tangxq *
@Last Modified time: 2021-07-19 15:18:52 * @Info:新品收集表单 */

<template>
  <div class="out-box">
    <van-form validate-first @failed="onFailed" @submit="onSubmit">
      <div class="collect-form">
        <!-- 通过 pattern 进行正则校验 -->
        <van-field
          required
          v-model="Name"
          :rules="[{ required: true, message: ' ' }]"
          name="Name"
          label="药品名称"
          placeholder="请输入药品名称"
        />
        <!-- 通过 validator 进行函数校验 -->
        <van-field
          label="药品规格 "
          required
          v-model="Specification"
          name="Specification"
          placeholder="请输入药品规格"
          :rules="[{ required: true, message: ' ' }]"
        />
        <!-- 通过 validator 进行异步函数校验 -->
        <van-field
          required
          label="药品供货价"
          v-model="SupplyPrice"
          name="SupplyPrice"
          placeholder="请输入药品供货价"
          :rules="[
            { required: true, message: '' },
            {validator:validatorNumber,message:'请输入大于0的数值'}
          ]"
          autocomplete="off"
          type="number"
          :formatter="priceFormatter"
          format-trigger="onBlur"
        />
        <van-field
          required
          label="药品月销量"
          v-model="MonthlySales"
          name="MonthlySales"
          placeholder="请输入药品月销量"
          :rules="[
            { required: true, message: '' },
            {validator:validatorNumber,message:'请输入大于0的数值'}
          ]"
          type="number"
          :formatter="saleFormatter"
          format-trigger="onBlur"
        />
        <van-field
          label="生产厂家"
          v-model="Manufacturer"
          name="Manufacturer"
          placeholder="请输入生产厂家"
        />
        <van-field
          label="药品零售价"
          v-model="RetailPrice"
          name="RetailPrice"
          placeholder="请输入药品零售价"
          format-trigger="onBlur"
          type="number"
          :formatter="priceFormatter"
          :rules="[
            {validator:validatorNumber,message:'请输入大于0的数值'}
          ]"
        />
        <!-- 图片上传 -->
        <van-field
          name="ImgList"
          label="药品图片"
          :rules="[{ required: false, message: '' }]"
        >
          <template #input>
            <van-uploader
              v-model="ImgList"
              :after-read="afterRead"
              :max-count="4"
              :preview-options="{
                showIndicators:true,
                closeable:true
              }"
            >
              <div class="upload-item">
                <van-icon
                  size="40px"
                  :name="
                    require('../../../../assets/mine/new-goods-upload-icon.png')
                  "
                />
                <div class="upload-tips">上传图片</div>
              </div>
            </van-uploader>
          </template>
        </van-field>
      </div>
      <van-button
        preview-size="2.04rem"
        class="sub-btn"
        round
        block
        type="info"
        native-type="submit"
        :disabled="isSubmitLoading"
        >确定</van-button
      >
    </van-form>
  </div>
</template>
<script>
import { oss, bucketConfig } from '@/utils/oss'
import { Toast } from 'vant'
export default {
  name: 'NewGoodsCollectForm',
  data() {
    return {
      Name: '',
      Specification: '',
      Manufacturer: '',
      SupplyPrice: '',
      RetailPrice: '',
      MonthlySales: '',
      pattern: /\d{6}/,
      ImgList: [],
      isSubmitLoading:false
    }
  },
  mounted() {},
  methods: {
    saleFormatter(val) {
      return val ? Math.floor(val) : ''
    },
    priceFormatter(value) {
      console.log(value)
      return value ? Number(value).toFixed(2) : ""
    },
    validatorNumber(val) {
      if (val !== '') {
        return Number(val) > 0
      }
      return true
    },
    onFailed(errorInfo) {
      //   const { errors } = errorInfo
      //   if (errors.length && errors.filter(item => item.name === 'ImgList').length) {
      //     this.$toast({ message: '请上传图片' })
      //   }
    },
    //
    getChooseImg() {
      this._file(
        (Data, b64) => {
          if (b64) {
            this.base64 = b64
          } else {
            this.base64 = ''
          }
          this.ImgList.push({ url: Data })
          //   this.$emit('change', Data)
        },
        '',
        '',
        false,
        'hys-cualifications'
      )
    },
    async afterRead(file) {
      file.status = 'uploading';
      // 此时可以自行将文件上传至服务器
      let url = await oss(
        this.getAction.bind(this),
        file,
        bucketConfig['hys-cualifications'],
        window.localStorage.getItem('UserId')
      )
      file.status = 'done';
      file.url = url
    },
    async onSubmit(values) {
      const toastLoading = this.$toast.loading({
        message: '',
        duration: 0,
        forbidClick: true,
      })
      this.isSubmitLoading = true
      try {
        const res = await this.putAction(
          '/api_goods/GoodsSku/addNewCollection',
          {
            ...values,
            CommitBodyType: 1,
            ImgList: values.ImgList.map((item) => item.url),
          }
        )
        if (res.IsSuccess && res.Data) {
          this.$toast({
            position: 'bottom',
            message: '提交成功~',
            onClose: () => {
              this.isSubmitLoading = false
              window.location.reload()
            },
          })
        } else {
          this.isSubmitLoading = false
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      } catch (error) {}
    },
  },
}
</script>
<style lang="less" scoped>
.collect-form {
  background-color: #ffffff;
  position: relative;
  .upload-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 101px;
    height: 101px;
    border-radius: 4px;
    border: 1px dashed #dfe1e8;
    cursor: pointer;
    // position: absolute;
    // z-index: 9;
    .upload-tips {
      color: #0f6eea;
      padding-top: 8px;
      font-size: 12px;
    }
  }
  /deep/ .van-cell {
    padding: 0 0 16px;
  }
  /deep/ .van-cell::after {
    display: none;
  }
  /deep/ .van-cell--required::before {
    display: none;
  }
  /deep/ .van-field__label {
    display: flex;
    align-items: center;
    width: 130px;
    justify-content: flex-end;
    padding-right: 12px;
  }
  /deep/ .van-field__label span {
    position: relative;
    font-weight: bold;
    display: flex;
  }
  /deep/ .van-cell--required .van-field__label span::after {
    color: #ee0a24;
    font-size: 14px;
    position: relative;
    content: '*';
    // right: -10px;
    width: 12px;
    display: inline-block;
    top: 3px;
    text-align: right;
  }
  /deep/ input {
    background: #f9fafb;
    border-radius: 4px;
    border: 1px solid #dfe1e8;
    height: 38px;
    line-height: 38px;
    padding-left: 12px;
    width: 327px;
    &.van-uploader__input{
      width: 100%;
      height: 100%;
    }
    &:hover {
      border-color: #0f6eea;
    }
  }
  //   submit btn
  /deep/ .van-uploader__preview-image {
    width: 102px;
    height: 102px;
  }
  /deep/ .van-uploader__input-wrapper {
    width: 101px;
    height: 101px;
  }
}
.sub-btn {
  width: 160px;
  height: 40px;
  background: #0f6eea;
  border-radius: 4px;
  font-size: 16px;
  margin: 80px 0 20px 370px;
}
</style>
